module.exports = __webpack_public_path__ + "static/media/m25_thumb.f86423f9.webp";